import { Box, Button, Stack, TextField, Typography } from '@mui/material'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { Colors } from '../../../../Styles/Colors';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

class DocSymptomsRight extends Component {
    constructor(props) {
        super(props)
        this.state = {
            obs_PICME: "",
            obs_Abortion: "",
            obs_LiveBirth: "",
            obs_Para: "",
            obs_Gravida: "",
            // obs_ExpectedDeliveryDate: null,
            // obs_LastMenstrualPeriod: null,
            isDisable: false,
        }
    }

    componentDidMount() {
        if (this.props.EditObstericData && Object.keys(this.props.EditObstericData).length !== 0) {
            this.updateEditobstericData();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.EditObstericData !== this.props.EditObstericData &&
            this.props.EditObstericData && Object.keys(this.props.EditObstericData).length !== 0) {
            this.updateEditobstericData();
        }
    }

    checkValue = (value) => {
        return (value !== undefined && value !== null);
    }

    updateEditobstericData = () => {
        const { EditObstericData, ClearPropsData } = this.props;
        this.setState({
            obs_PICME: this.checkValue(EditObstericData?.picme) ? EditObstericData?.picme : "",
            obs_Abortion: this.checkValue(EditObstericData?.abortions) ? EditObstericData?.abortions : "",
            obs_LiveBirth: this.checkValue(EditObstericData?.live_births) ? EditObstericData?.live_births : "",
            obs_Para: this.checkValue(EditObstericData?.para) ? EditObstericData?.para : "",
            obs_Gravida: this.checkValue(EditObstericData?.gravida) ? EditObstericData?.gravida : "",
            // obs_ExpectedDeliveryDate: EditObstericData?.expected_date_of_delivery ? DateTime.fromFormat(EditObstericData.expected_date_of_delivery, "dd-MM-yyyy") : null,
            // obs_LastMenstrualPeriod: EditObstericData?.last_menstrual_period ? DateTime.fromFormat(EditObstericData.last_menstrual_period, "dd-MM-yyyy") : null
        }, () => {
            ClearPropsData()
        })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message,
            isDisable: false,
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message,
            isDisable: false,
        })
    }

    ClearData() {
        this.setState({
            obs_PICME: "",
            obs_Abortion: "",
            obs_LiveBirth: "",
            obs_Para: "",
            obs_Gravida: "",
            // obs_ExpectedDeliveryDate: null,
            // obs_LastMenstrualPeriod: null,
        })
    }

    PostObstericData = () => {
        try {
            const states = this.state
            const data = {
                "patient_id": this.props.PatientData.patient_id,
                "appointment_id": this.props?.PatientData?.appointment_id,
                // "last_menstrual_period": states.obs_LastMenstrualPeriod ? DateTime.fromJSDate(new Date(states.obs_LastMenstrualPeriod)).toFormat("yyyy-MM-dd") : "",
                // "expected_date_of_delivery": states.obs_ExpectedDeliveryDate ? DateTime.fromJSDate(new Date(states.obs_ExpectedDeliveryDate)).toFormat("yyyy-MM-dd") : "",
                "last_menstrual_period": null,
                "expected_date_of_delivery": null,
                "gravida": states.obs_Gravida ? +states.obs_Gravida : 0,
                "para": states.obs_Para ? +states.obs_Para : 0,
                "live_births": states.obs_LiveBirth ? +states.obs_LiveBirth : 0,
                "abortions": states.obs_Abortion ? +states.obs_Abortion : 0,
                "picme": states.obs_PICME || "",
            }

            RestAPIService.create(data, Serviceurls.DOC_OBSTETRIC_DATA_GET)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.successMessage(response.data.message)
                        this.props.CallgetApi('obstetric_data')
                    } else {
                        this.errorMessage(response.data.message)
                    }
                }).catch(error => {
                    this.errorMessage(error.response.data.message || error.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    returnTextField = (label, stateKey, MaxLength = 15) => {
        const { t } = this.props
        let states = this.state
        const fieldId = `doc_obsteric_data_right_${stateKey.toLowerCase()}`
        return (
            <Box sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '0.5vw',
                margin: '0.5vw'
            }} emed_tid={`${fieldId}_box`}>
                <Typography emed_tid={`${fieldId}_label`}>{t(label)}</Typography>
                <TextField
                    emed_tid={`${fieldId}_textfield`}
                    size='small'
                    label={t(label)}
                    fullWidth
                    inputProps={{ maxLength: MaxLength, emed_tid: `${fieldId}_input` }}
                    onChange={(e) => {
                        const { value } = e.target;
                        if (CommonValidation.numberOnly(value) || value === "") {
                            this.setState({ [stateKey]: value })
                        }
                    }}
                    value={states[stateKey]}
                    autoComplete='off' />
            </Box>
        )
    }

    // returnDateField = (label, stateKey) => {
    //     const { t } = this.props
    //     let states = this.state
    //     return (
    //         <Box sx={{
    //             display: 'grid',
    //             gridTemplateColumns: 'repeat(2, 1fr)',
    //             gap: '0.5vw',
    //             margin: '0.5vw'
    //         }}>
    //             <Typography>{t(label)}</Typography>
    //             <LocalizationProvider dateAdapter={AdapterDayjs}>
    //                 <DatePicker
    //                     value={states[stateKey]}
    //                     inputFormat='DD-MM-YYYY'
    //                     views={["year", "month", "day"]}
    //                     maxDate={stateKey === "obs_LastMenstrualPeriod" ? new Date() : null}
    //                     minDate={stateKey === "obs_ExpectedDeliveryDate" ? new Date() : null}
    //                     onChange={(newDate) => {
    //                         if (stateKey === "obs_LastMenstrualPeriod") {
    //                             states[stateKey] = newDate
    //                             states["obs_ExpectedDeliveryDate"] = new Date(new Date(newDate).getTime() + 40 * 7 * 24 * 60 * 60 * 1000);
    //                         } else {
    //                             states[stateKey] = newDate
    //                         }
    //                         this.setState({ states })
    //                     }}
    //                     renderInput={(params) => <TextField
    //                         onKeyDown={(e) => e.preventDefault()}
    //                         sx={{ width: "100%" }}
    //                         size='small' {...params}
    //                     />}
    //                 />
    //             </LocalizationProvider>
    //         </Box>
    //     )
    // }

    render() {
        const { t } = this.props;
        const {isDisable, obs_PICME, obs_Gravida, obs_Para, obs_LiveBirth, obs_Abortion} = this.state;
        return (
            <Box emed_tid="doc_obsteric_data_right_container">
                <Typography className='eMed_refdoc_title' emed_tid="doc_obsteric_data_right_title">{this.props.SelectedCompCustomName ? this.props.SelectedCompCustomName : 'Obstetric Data'}</Typography>
                <Box height={"56.3vh"} sx={{ overflowY: 'auto' }} emed_tid="doc_obsteric_data_right_content">
                    {this.returnTextField("PICME", "obs_PICME")}
                    {this.returnTextField("Gravida", "obs_Gravida", 10)}
                    {this.returnTextField("Para", "obs_Para", 10)}
                    {this.returnTextField("Live Birth", "obs_LiveBirth", 3)}
                    {this.returnTextField("Abortion", "obs_Abortion", 3)}
                    {/* {this.returnDateField("Last Menstrual Period *", "obs_LastMenstrualPeriod")}
                    {this.returnDateField("Expected date of delivery *", "obs_ExpectedDeliveryDate")} */}
                </Box>
                <Stack spacing={2} direction="row" sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center" height={"6vh"} emed_tid="doc_obsteric_data_right_actions">
                    <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={() => { this.ClearData() }} emed_tid="doc_obsteric_data_right_clear_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small" id="eMed_Config_btn"
                        disabled={isDisable || (!obs_PICME && !obs_Gravida && !obs_Para && !obs_LiveBirth && !obs_Abortion)}
                        onClick={() => {
                            this.setState({ isDisable: true }, () => { this.PostObstericData() })
                        }} emed_tid="doc_obsteric_data_right_add_btn">Add</Button>
                </Stack>
                {this.state.isErrorMsg &&
                    <ToastMsg
                        emed_tid="doc_obsteric_data_right_error_toast"
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />}
                {this.state.successMsg &&
                    <ToastMsg
                        emed_tid="doc_obsteric_data_right_success_toast"
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />}
            </Box>
        )
    }
}
export default withTranslation()(DocSymptomsRight)